import AbstractModel, { Model } from './abstract-model';

@Model('CavitesLine')
export default class CavitesLine extends AbstractModel {
  public gid: number = null; //int
  public numCavite: string = null;
  public numSite: string = null;
  public typeData: string = null;
  public nomSite: string = null;
  public typeObjet: string = null;
  public nature: string = null;
  public etage: string = null;
  public observatio: string = null;
  public source: string = null;
  public geomL93: any = null;

}

